// Register page helpers (POS-I180, POS-I181, POS-I182) kept as plain functions so they have a spec.

export const BUSINESS_ID_MAX = 40;

/** A Business ID suggested from the business name: lowercase letters, digits and hyphens, at most 40 characters. */
export function slugFromName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+/, '')
    .slice(0, BUSINESS_ID_MAX)
    .replace(/-+$/, '');
}

export type RegisterField = 'tenantName' | 'tenantSlug' | 'firstName' | 'lastName' | 'email' | 'phone' | 'password';

/**
 * Which field a server refusal belongs to, from the sentence the API sends. The sentence itself is
 * shown under that field; a message that names no field (or a server error) stays a toast.
 */
export function registerErrorField(message: string): RegisterField | null {
  if (/^Business ID/i.test(message)) return 'tenantSlug';
  if (/^Business name/i.test(message)) return 'tenantName';
  if (/^First name/i.test(message)) return 'firstName';
  if (/^Last name/i.test(message)) return 'lastName';
  if (/phone number/i.test(message)) return 'phone';
  if (/^Password|password is too common/i.test(message) || /^This password/i.test(message)) return 'password';
  if (/^(Email|A user with this email)/i.test(message)) return 'email';
  return null;
}
